/**
 * This file is used to determine the API url according to the environment set
 */

import { DASHBOARD_RESOURCES } from 'constant';

// const LOCAL_URL = 'http://localhost:5098';

const ENVIRONMENT = {
	STAGING: 'staging',
	PRODUCTION: 'production',
	QA: 'qa',
	TOURNAMENT_STAGING: 'staging'
};

const { STAGING, PRODUCTION, QA } = ENVIRONMENT;

// Placeholders are replaced by docker-entrypoint.sh as per environment
// Falls back to staging for local development where placeholders are not replaced
const RAW_ENV = '__REACT_APP_NODE_ENV__';
const CURRENT_ENV = RAW_ENV.startsWith('__') ? ENVIRONMENT.STAGING : RAW_ENV;
// Local dev fallbacks (when placeholders are not replaced by docker-entrypoint.sh)
const resolve = (placeholder: string, fallback: string): string => (placeholder.startsWith('__') ? fallback : placeholder);

const authUrl = resolve('__REACT_APP_AUTH_SERVICE_BASE_URL__', 'https://cse-auth-service.ludojoy.com');
const adminUrl = resolve('__REACT_APP_ADMIN_SERVICE_BASE_URL__', 'https://cse-admin-service.ludojoy.com');
const gClient = resolve('__REACT_APP_GCLIENT_ID__', '519096840473-r7abmbvlmdvka454jjvpqaucpsa3715p.apps.googleusercontent.com');
const adminBasicAuth = resolve(
	'__REACT_APP_ADMIN_BASIC_AUTH__',
	'Basic enVwZWU6S1ZNTGxEQ2V1Y2ZOTm9TdWFSTlhPRFFJejVKNVBWUXBvM2VsSHFvcndYOXVmaEFGT21Hb0pVRDZTUHN4'
);
const encryptionKey = resolve('__REACT_APP_ENCRYPT_KEY__', '1234567890');

export const EXTERNAL_MERCHANT_PREFIX = 'https://matrix.ludosupreme.com/';
const ENV_AI_CHAT_GATEWAY_URL_MAP = {
	[ENVIRONMENT.STAGING]: 'https://cse-ai-chat-gateway.ludojoy.com',
	[ENVIRONMENT.PRODUCTION]: 'https://ai-chat-gateway.ludosupreme.com',
	[ENVIRONMENT.QA]: 'https://ai-chat-gateway-qa.ludojoy.com'
};

const URL_ENV_MAP: Record<string, Record<string, string>> = {
	[ENVIRONMENT.STAGING]: {
		[DASHBOARD_RESOURCES.ruleEngine]: 'https://webstore.ludojoy.com',
		[DASHBOARD_RESOURCES.tournamentV2]: 'https://vortex.ludojoy.com/tournamentV2'
	},
	[ENVIRONMENT.QA]: {
		[DASHBOARD_RESOURCES.ruleEngine]: 'https://beta-rewards.ludosupreme.com',
		[DASHBOARD_RESOURCES.tournamentV2]: 'https://vortex.ludojoy.com/tournamentV2'
	},
	[ENVIRONMENT.PRODUCTION]: {
		[DASHBOARD_RESOURCES.ruleEngine]: 'https://rulecraft-engine.ludosupreme.com',
		[DASHBOARD_RESOURCES.tournamentV2]: 'https://vortex.ludosupreme.com/tournamentV2'
	}
};

const ENV_GCLIENT_MAP = {
	[STAGING]: gClient || '415377915708-v5m88liq9b1or1elc7k4slfk9q9bedo1.apps.googleusercontent.com',
	[PRODUCTION]: gClient || '519096840473-r7abmbvlmdvka454jjvpqaucpsa3715p.apps.googleusercontent.com',
	[QA]: gClient || '415377915708-v5m88liq9b1or1elc7k4slfk9q9bedo1.apps.googleusercontent.com'
};
const ENV_AUTH_URL_MAP = {
	[ENVIRONMENT.STAGING]: authUrl || 'https://cse-auth-service.ludojoy.com',
	[ENVIRONMENT.PRODUCTION]: authUrl || 'https://auth.ludosupreme.com',
	[ENVIRONMENT.QA]: authUrl || 'https://cse-auth-service.ludojoy.com'
};

const ENV_ADMIN_URL_MAP = {
	[ENVIRONMENT.STAGING]: adminUrl || 'https://cse-admin-service.ludojoy.com',
	[ENVIRONMENT.PRODUCTION]: adminUrl || 'https://admin.ludosupreme.com',
	[ENVIRONMENT.QA]: adminUrl || 'https://cse-admin-service.ludojoy.com'
};
const ENV_ADMIN_BASIC_AUTH_MAP = {
	[ENVIRONMENT.STAGING]:
		adminBasicAuth || 'Basic enVwZWU6S1ZNTGxEQ2V1Y2ZOTm9TdWFSTlhPRFFJejVKNVBWUXBvM2VsSHFvcndYOXVmaEFGT21Hb0pVRDZTUHN4',
	[ENVIRONMENT.PRODUCTION]:
		adminBasicAuth || 'Basic c3VwcmVtZWx1ZG86U1gyb28wazZjY3JoRkxyMUtUZVlHSUFsdFRUd1hvanhmUFprbGNVVFRzY0RmYkw2QUNmYkgzWkowWHpz',
	[ENVIRONMENT.QA]: adminBasicAuth || 'Basic enVwZWU6aGVsbG93b3JsZA=='
};

export default {
	ENVIRONMENTS: ENVIRONMENT,
	API_URL: ENV_AUTH_URL_MAP[CURRENT_ENV],
	GCLIENT_ID: ENV_GCLIENT_MAP[CURRENT_ENV],
	ADMIN_API_URL: ENV_ADMIN_URL_MAP[CURRENT_ENV],
	URL_ENV_MAP: URL_ENV_MAP[CURRENT_ENV],
	ADMIN_BASIC_AUTH: ENV_ADMIN_BASIC_AUTH_MAP[CURRENT_ENV],
	ENCRYPTION_KEY: encryptionKey,
	AI_CHAT_GATEWAY_URL: ENV_AI_CHAT_GATEWAY_URL_MAP[CURRENT_ENV]
};
